export const MsgType = {
	InitConnect: 0,
	LoadRequest : 1,
	NewOrder: 2,
	ApproveRequest: 3,
	PingPong: 3,
	ConfirmedOrder: 5,
	ErrorNeedToHandle: 4
}

export const LoginType = {
	Token: 0,
	Account: 1
}

export const Status = {
	OK: 0,
	SUCCESS : 1,
	PROCESSING: 2,
	PENDING: 3,
	// SUCCESS: 4,
	FAILED: 5
};

export const StatusMsg = {
	1: "Thành công",
	3: "Đang xử lý",
	5: "Thất bại",
};